// Copyright (c) StrangeBee 2023

export const numberSignLabel = [
    {
        label: '=',
        value: 'eq',
    },
    {
        label: '!=',
        value: 'not',
    },
    {
        label: '<',
        value: 'lt',
    },
    {
        label: '<=',
        value: 'lte',
    },
    {
        label: '>',
        value: 'gt',
    },
    {
        label: '>=',
        value: 'gte',
    },
];

export const booleanSignLabel = [
    {
        label: 'Yes',
        value: 'true',
    },
    {
        label: 'No',
        value: 'false',
    },
    {
        label: 'Any',
        value: 'any',
    },
];

export const stringSignLabel = [
    {
        label: 'any of',
        value: 'any',
    },
    {
        label: 'all of',
        value: 'all',
    },
    {
        label: 'none of',
        value: 'not',
    },
    {
        label: 'is empty',
        value: 'is empty',
    },
    {
        label: 'is not empty',
        value: 'is not empty',
    },
];

export const dateSignLabel = [
    {
        label: 'custom',
        value: 'custom',
    },
    {
        label: 'last 7 days',
        value: 'last7days',
    },
    {
        label: 'last 30 days',
        value: 'last30days',
    },
    {
        label: 'last 3 months',
        value: 'last3months',
    },
    {
        label: 'last 6 months',
        value: 'last6months',
    },
    {
        label: 'last year',
        value: 'lastyear',
    },
    {
        label: 'today',
        value: 'today',
    },
];

export const operatorSignLabel = {
    string: stringSignLabel,
    url: stringSignLabel,
    enumeration: stringSignLabel,
    user: stringSignLabel,
    boolean: booleanSignLabel,
    number: numberSignLabel,
    integer: numberSignLabel,
    float: numberSignLabel,
    date: dateSignLabel,
};
